// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ZoomInOutlinedSvg from "@fishx/icons-svg/es/asn/ZoomInOutlined";
import FishxIcon from '../components/FishxIcon';

var ZoomInOutlined = function ZoomInOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ZoomInOutlinedSvg
  }));
};

ZoomInOutlined.displayName = 'ZoomInOutlined';
export default React.forwardRef(ZoomInOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ZoomInOutlined.js
// module id = 4436
// module chunks = 0